import { OptionsStateType } from "../types/state-types";
import {
  ChoicesAndLine,
  ChoicesWithLine,
  CopyActionPayload,
  OptionActions,
  OptionsType,
} from "../types/option";
import {
  COPY_OPTIONS,
  COPY_LINE_OPTIONS,
  DELETE_SAVED_LINE_OPTIONS,
  MODIFY_OPTIONS,
  UPDATE_OPTION_FOR_LINE,
} from "../constants/actionTypesTpos";
import { cloneDeep } from "lodash";
import {
  CLEAR_BASKET,
  CLEAR_BASKET_AFTER_ORDER,
} from "../constants/actionTypes";

export const INITIAL_STATE = {
  currentLineOptions: undefined,
  lineOptions: {},
};

const getImmutableLineOptions = (
  options: OptionsType[] | undefined,
  optionId: number,
  choiceId: number,
): OptionsType[] => {
  if (!options) {
    return [];
  }
  const lineOptions = cloneDeep(options);

  lineOptions?.map((option) => {
    if (option.id === optionId) {
      option.choices.map((choice) => {
        if (choice.id === choiceId) {
          choice.selected = true;
        } else {
          choice.selected = false;
        }
        return choice;
      });
    }
  });
  return lineOptions;
};

const modifyOption = (
  state: OptionsStateType,
  { lineId, optionId, choiceId }: ChoicesAndLine,
) => {
  const lineOption = state.currentLineOptions
    ? state.currentLineOptions[lineId]
    : undefined;
  const lineOptions = getImmutableLineOptions(lineOption, optionId, choiceId);
  return {
    ...state,
    currentLineOptions: {
      ...state.currentLineOptions,
      [lineId]: lineOptions || [],
    },
  };
};

const updateOptionForLine = (
  state: OptionsStateType,
  { lineId }: ChoicesWithLine,
) => {
  const lineOption = state.currentLineOptions
    ? state.currentLineOptions[lineId]
    : undefined;
  return {
    ...state,
    lineOptions: {
      ...state.lineOptions,
      [lineId]: lineOption || [],
    },
  };
};

const copyOptions = (
  state: OptionsStateType,
  { lineId, options }: CopyActionPayload,
) => {
  return {
    ...state,
    currentLineOptions: {
      ...state.currentLineOptions,
      [lineId]: options,
    },
  };
};

const copyLineOptions = (
  state: OptionsStateType,
  { lineId, options }: CopyActionPayload,
) => {
  return {
    ...state,
    lineOptions: {
      ...state.lineOptions,
      [lineId]: options,
    },
  };
};

const deleteLineOptions = (
  state: OptionsStateType,
  { lineId }: ChoicesWithLine,
) => {
  return {
    ...state,
    currentLineOptions: {
      ...state.currentLineOptions,
      [lineId]: undefined,
    },
    lineOptions: {
      ...state.lineOptions,
      [lineId]: undefined,
    },
  };
};

const optionsReducer = (
  state: OptionsStateType = INITIAL_STATE,
  action: OptionActions,
): OptionsStateType => {
  switch (action.type) {
    case COPY_OPTIONS: {
      return copyOptions(state, action.payload);
    }
    case COPY_LINE_OPTIONS: {
      return copyLineOptions(state, action.payload);
    }
    case MODIFY_OPTIONS: {
      return modifyOption(state, action.payload);
    }
    case UPDATE_OPTION_FOR_LINE: {
      return updateOptionForLine(state, action.payload);
    }
    case DELETE_SAVED_LINE_OPTIONS: {
      return deleteLineOptions(state, action.payload);
    }
    case CLEAR_BASKET_AFTER_ORDER:
    case CLEAR_BASKET: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
export default optionsReducer;
